/**
 * @module core/schemas
 */

// Definitions
import { ISchemaPage } from '../defs';

/**
 * See [[ISchemaPage]]
 */
export const schemaPage: ISchemaPage = {
  container: null,
  html: '',
  namespace: '',
  url: {
    hash: '',
    href: '',
    path: '',
    port: null,
    query: {},
  },
};
